// extracted by mini-css-extract-plugin
export var brand = "_1w-9";
export var compact = "_1w-6";
export var extraSmall = "_1w-7";
export var icon = "_1w-0";
export var large = "_1w-4";
export var light = "_1w-1";
export var medium = "_1w-5";
export var outline = "_1w-b";
export var primaryDark = "_1w-a";
export var primaryLight = "_1w-8";
export var primaryModern = "_1w-c";
export var success = "_1w-2";
export var successSolid = "_1w-3";